const { routes } = require('./index_');

module.exports = {
    routes: Object.freeze(routes)
};
